module.exports = __webpack_public_path__ + "img/1602347494.c283eccc.png";